import { RefObject, useEffect, useState } from 'react';

import { LONG_HERO_VIEWPORT_RATIO } from '../constants/ui';
import { DomEventEnum } from '../types/shell';

export const useIsLongHero = (heroRef: RefObject<HTMLElement> | undefined): boolean => {
  const [isLongHero, setIsLongHero] = useState(false);

  useEffect(() => {
    const measure = () => {
      const hero = heroRef?.current;
      setIsLongHero(!!hero && hero.offsetHeight >= window.innerHeight * LONG_HERO_VIEWPORT_RATIO);
    };

    measure();
    window.addEventListener(DomEventEnum.Resize, measure);

    const observedHero = heroRef?.current;
    let observer: ResizeObserver | null = null;
    if (observedHero && typeof ResizeObserver !== 'undefined') {
      observer = new ResizeObserver(measure);
      observer.observe(observedHero);
    }

    return () => {
      window.removeEventListener(DomEventEnum.Resize, measure);
      observer?.disconnect();
    };
  }, [heroRef]);

  return isLongHero;
};
